.priceDropsModal {
  --modal-animation-transform: translateY(10%);

  @media (min-width: 769px) {
    height: 100%;
    max-height: 100%;
    --modal-animation-transform: translateX(8%);
  }

  @media (min-width: 1025px) {
    top: 2rem;
    left: calc(50% - 0.3125rem);
    width: calc(100% - 4rem);
    max-width: 96rem;
    height: calc(100dvh - 2rem);
    border-top-left-radius: 1.5rem;
    border-top-right-radius: 1.5rem;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
    transform: translateX(-50%);
  }

  > .overlay {
    @media (min-width: 769px) {
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
    }
  }

  > .content {
    @media (min-width: 769px) {
      width: 33rem;
      height: 100%;
      max-height: 100%;
      margin: 0 0 0 auto;
      border-radius: 0;
      box-shadow:
        rgba(14, 33, 24, 0.04) 0px 1px 2px,
        rgba(14, 33, 24, 0.12) 0px 12px 32px,
        rgba(14, 33, 24, 0.22) 0px 32px 64px -16px !important;
    }

    @media (min-width: 1025px) {
      border-top-left-radius: 0;
      border-top-right-radius: 1.5rem;
      border-bottom-right-radius: 0;
      border-bottom-left-radius: 0;
    }
  }

  .head {
    margin: -1.25rem -1.25rem 0;
    padding: 1.25rem 1rem 1rem;
    border-bottom: 0.0625rem solid var(--neutral-200);
    background: linear-gradient(rgb(246, 241, 230) 0%, rgb(255, 255, 255) 110%);
    gap: 0.75rem;

    .savings {
      margin: 0 0 0.5rem;
      letter-spacing: 0.05rem;
    }

    .title {
      display: flex;
      align-items: center;
      gap: 0.75rem;

      .counter {
        position: relative;
        top: 0.0625rem;
        padding: 0.125rem 0.625rem 0.0625rem;
        border-radius: 99rem;
        line-height: 145%;
        background-color: var(--primary-600);
      }
    }
  }

  .list {
    margin: 0 -1.25rem -1.25rem;
    padding: 0 1.125rem 4rem;

    @media (min-width: 769px) {
      padding: 0 1.25rem 4rem;
    }

    .group {
      display: flex;
      flex-direction: column;
      margin: 1rem 0 1.75rem;

      @media (min-width: 769px) {
        margin: 1rem 0 1rem;
      }

      .groupTitle {
        display: flex;
        justify-content: space-between;
        margin: 0 0 0.5rem;
        text-transform: uppercase;
        letter-spacing: 0.05rem;

        .skeleton {
          height: 1.125rem;

          &:first-child {
            width: 4.5rem;
            margin: 0 1rem 0 0;
          }

          &:last-child {
            margin: 0 0 0 auto;
            width: 9rem;
          }
        }
      }

      .priceDrop {
      }
    }
  }
}
